import { useState } from "react";
import { CompanyEquipmentData } from "../../types/companyEquipments.type";
import EditEquipmentUsageModal from "../EditEquipmentUsageModal";
import Button from "@/common/components/Button";
import { FileEditIcon } from "lucide-react";

interface UpdateLastUsageDeclarationsPerCategoryProps {
  equipment: CompanyEquipmentData;
  categoryId?: string;
  categoryName?: string;
  value: number;
}

const UpdateLastUsageDeclarationsPerCategory = ({
  equipment,
  categoryId,
  categoryName,
  value,
}: UpdateLastUsageDeclarationsPerCategoryProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant="link-white"
        operationKlassToCheckPermission="Admin::Client::Equipments::CreateLastUsageDeclaration"
        onClick={() => setIsOpen(true)}
      >
        <FileEditIcon strokeWidth={1} />
      </Button>

      <EditEquipmentUsageModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        equipmentId={equipment.id!}
        unitForConsumption={equipment.model?.category.unit_for_consumption}
        initialValue={value}
        categoryId={categoryId}
        categoryName={categoryName}
      />
    </>
  )
}

export default UpdateLastUsageDeclarationsPerCategory;
